export default __webpack_public_path__ + "static/media/plain-sticker-r.4fd6662c.png";